"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailImg = exports.AssetDetailImageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AssetDetailImageContainer = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color: ${props => props.theme.color.gray9};
`;
exports.AssetDetailImg = styled_components_1.default.img `
	max-height: 100%;
	max-width: 100%;
	object-fit: contain;
`;
